import { render, staticRenderFns } from "./OnboardingTaskButton.vue?vue&type=template&id=1e668758&scoped=true&"
import script from "./OnboardingTaskButton.vue?vue&type=script&lang=js&"
export * from "./OnboardingTaskButton.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingTaskButton.vue?vue&type=style&index=0&id=1e668758&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e668758",
  null
  
)

export default component.exports